import { Component } from 'react';
import styled, { css } from 'styled-components';
import { IconMovie } from '@yj-intl/riff-react';
import { radius, fontSize } from '../../../../../common/css/setting/variable';
import LabelIcon from '../modules/LabelIcon';
import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import OriginalLabel from '../modules/OriginalLabel';

interface ListItemProps {
  $isPickedImage: boolean;
}

const ListItem = styled.li<ListItemProps>`
  position: relative;
  font-size: ${fontSize.px15};
  border-bottom: 1px dotted ${props => props.theme.news.palette.bor_lv2_pc}; /* コンテンツ内の区切りだが破線のためLv2（ちょっと濃いめ）を用いる */

  /* 画像表示しているトピの吹き出し部分「＜」 */
  ${({ $isPickedImage }) =>
    $isPickedImage
      ? css`
          &::before,
          &::after {
            position: absolute;
            top: 50%;
            width: 0;
            height: 0;
            margin-top: -8px;
            content: '';
            border: 8px solid transparent;
          }
          &::before {
            right: -17px;
            border-right: 10px solid ${props => props.theme.news.palette.bor_lv2_pc};
          }
          &::after {
            right: -18px;
            border-right: 10px solid ${props => props.theme.news.palette.text_white_common};
          }
        `
      : ''}
`;

const Link = styled.a`
  ${pcVisitedLink}
  position: relative;
  display: block;
  padding: 6px 0px 6px 15px;

  /* 行頭の丸ポチ */
  &::before {
    position: absolute;
    top: 50%;
    left: 5px;
    display: block;
    width: 4px;
    height: 4px;
    margin-top: -2px;
    content: '';
    background-color: ${props => props.theme.news.palette.bor_lv2_pc};
    border-radius: ${radius.small_common};
  }
`;

const OriginalIconWrapper = styled.span`
  padding-left: 5px;
`;
const LabelIconWrapper = styled.span`
  display: inline-block;
  margin-left: 4px;
  font-size: 0; /* 縦を揃える */
  vertical-align: middle;
`;

const StyledIconMovie = styled(IconMovie)`
  /* ちょうどいいカラーがなかったのでriffのカラパレをお試し導入 */
  color: #696969;

  &:hover,
  &:visited {
    color: #696969;
  }
`;
interface IProps {
  id: number;
  url: string;
  title: string;
  hasVideo: boolean;
  isNew: boolean;
  isLive: boolean;
  dataClParams: string;
  isPickedImage: boolean;
  dataUal: string;
  articleIsOriginal?: boolean;
}

export default class TopicsListItem extends Component<IProps> {
  /**
   *
   */
  public render() {
    // トップ以外でも利用されていそうなので出し分け
    return (
      <ListItem
        key={this.props.id}
        $isPickedImage={this.props.isPickedImage}
        data-ual-view-type="list"
        data-ual={this.props.dataUal}
      >
        <Link href={this.props.url} data-cl-params={this.props.dataClParams} data-ual-gotocontent>
          {this.props.title}
          {this.props.hasVideo ? (
            <LabelIconWrapper>
              <StyledIconMovie size={18} aria-label="動画" />
            </LabelIconWrapper>
          ) : null}
          {/* newアイコンとliveアイコンとオリジナルアイコンは同時に最大1つまで表示する(優先度: new or live > オリジナル) */}
          {/* newアイコンと、liveアイコンはトピックス入稿ツール(TOMATO)で同時に出ないように制御されている */}
          {this.props.isNew ? (
            <LabelIconWrapper>
              <LabelIcon type="NEW" />
            </LabelIconWrapper>
          ) : null}
          {this.props.isLive ? (
            <LabelIconWrapper>
              <LabelIcon type="LIVE" />
            </LabelIconWrapper>
          ) : null}
          {/* オリジナルラベルはトップでは付与し、トピックス一覧では付与しない */}
          {!this.props.isNew && !this.props.isLive && this.props.articleIsOriginal && (
            <OriginalIconWrapper>
              <OriginalLabel />
            </OriginalIconWrapper>
          )}
        </Link>
      </ListItem>
    );
  }
}
